import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import DocumentTheme from "../../components/DocumentTheme";
import PageLayout from "../../components/PageLayout";
import CaseList from "./CaseList";
import CaseDetails from "./CaseDetails";
import ProbateCaseDetails from "./probate/ProbateCaseDetails";
import RequestGroupCollectionPage from "./probate/RequestGroupCollectionPage";
import CaseDoable from "./CaseDoable";
import Notification from "./Notification";
import ByCaseType from "./ByCaseType";
import ProbateMessage from "./probate/ProbateMessage";
import { ProbateMessagesPage } from "./probate/ProbateMessages";
import CaseArchive from "./CaseArchive";
import ProbateCaseArchive from "./probate/ProbateCaseArchive";
import ProbateEstate from "./probate/ProbateEstate";
import ProbateAddEstateItem from "./probate/ProbateAddEstateItem";
import ProbateConfirmEmail from "./probate/ProbateConfirmEmail";
import { useProbateTheme } from "./utils/hooks";

const ToCasePage = () => <Navigate to=".." relative="path" replace />;

const ClientDashboard = (props) => {
  const location = useLocation();

  const isCaseList = location.pathname === "/dashboard";
  const probateTheme = useProbateTheme();

  return (
    <PageLayout pageWidth={probateTheme ? "widest" : "wide"} showLogout={true} background={isCaseList ? "white" : null}>
      {probateTheme && <DocumentTheme name="probate" />}
      <Routes>
        <Route path="/" element={<CaseList pageWidth="wide" />} />
        <Route path="/:caseRef" element={<ByCaseType conveyancing={CaseDetails} probate={ProbateCaseDetails} />} />
        <Route
          path="/:caseRef/to-do/:collectionIdentifier"
          element={<ByCaseType conveyancing={CaseDetails} probate={RequestGroupCollectionPage} />}
        />
        <Route
          path="/:caseRef/things-youve-done"
          element={<ByCaseType conveyancing={CaseArchive} probate={ProbateCaseArchive} />}
        />
        <Route path="/:caseRef/estate" element={<ByCaseType conveyancing={ToCasePage} probate={ProbateEstate} />} />
        <Route
          path="/:caseRef/estate/add"
          element={<ByCaseType conveyancing={ToCasePage} probate={ProbateAddEstateItem} />}
        />
        <Route
          path="/:caseRef/confirm-email"
          element={<ByCaseType conveyancing={ToCasePage} probate={ProbateConfirmEmail} />}
        />
        <Route path="/:caseRef/messages" element={<ProbateMessagesPage />} />
        <Route
          path="/:caseRef/messages/:notificationId"
          element={<ByCaseType conveyancing={Notification} probate={ProbateMessage} />}
        />
        <Route path="/doable/:doableId" element={<CaseDoable />} />
        {/* The old referral page, replaced by the referral card on the case page; kept so existing links still land on the dashboard */}
        <Route path="/referral" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </PageLayout>
  );
};

export default ClientDashboard;
